import type { JSX } from 'react';

import { BurgerButton } from './styles';

const Burger = ({ onClick }: { onClick: () => void }): JSX.Element => {
  return <BurgerButton id="burger" onClick={onClick} />;
};

export { Burger };
